import { usePlanFeatureContext } from "../context/PlanFeatureContext"

/**
 * Firmanın kullanabildiği özellikler ve özellik deneme durumu.
 *
 * Veri `PlanFeatureProvider` tarafından tek kez yüklenir (bkz. PlanFeatureContext);
 * bu kancanın kendisi istek atmaz. Provider dışında çağrılırsa hiçbir şeyi
 * kısıtlamayan güvenli varsayılan döner.
 *
 * Paket dışı bir özellik menüde kilitli gösterilmez: menü normal çizilir,
 * tıklanınca `FeatureTrialModal` açılır ve kullanıcı ya ücretsiz denemeyi başlatır
 * ya da paket yükseltme ekranına gider.
 *
 * **Güvenlik sınırı değildir** — asıl reddetme backend'deki
 * `PlanFeatureInterceptor` tarafından yapılır (403).
 */
export const usePlanFeatures = () => usePlanFeatureContext()

export default usePlanFeatures
